export const LOGIN_TEXT = {
    TEXT_VIEW_1_1: 'Register your account with',
    TEXT_VIEW_1_2: 'International Camping Association',
    TEXT_VIEW_1_3:
        'A passcode to complete registration will be sent to your email.',
    TEXT_VIEW_1_FORM_1: 'Enter the email associated with your account',
    TEXT_VIEW_2_1: 'Sent!',
    TEXT_VIEW_2_2: 'Enter the passcode provided in the email we sent to you.',
    TEXT_VIEW_2_FORM_1: '6-digit passcode:',
    TEXT_VIEW_3_1: 'Complete!',
    TEXT_VIEW_3_2: 'You’ve successfully joined CampfireSocial.',
    TEXT_VIEW_5_1:
        'Join a campfire and conversation by setting up your profile.'
};

export const validateEmail = email => {
    const regex =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (regex.test(email)) {
        return true;
    } else {
        return false;
    }
};

export const getBase64 = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

export const saveDataLocal = data => {
    localStorage.setItem('mydata', JSON.stringify(data));
};
export const getDataLocal = () => {
    return JSON.parse(localStorage.getItem('mydata'));
};

export const filterCountryRegion = (code, CountryRegionData) => {
    const arrayCountryName = CountryRegionData.filter(country => {
        return country[1] === code ? country[0] : null;
    });
    return arrayCountryName;
};
